import { useCallback } from 'react';
import { NavigateFunction, NavigateOptions, useNavigate } from 'react-router-dom';

const onNavigate = (navigate: NavigateFunction, path: string, options?: NavigateOptions) => navigate('../' + path, options);

export const useRouteHook = () => {
  const navigate = useNavigate();

  const navigateTo = useCallback((path: string, options?: NavigateOptions) => onNavigate(navigate, path, options), [navigate]);
  const back = useCallback(() => navigate(-1), [navigate]);

  return { navigate: navigateTo, back };
};
